import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const STALE_TIME_MS = 60_000; // cache queries as fresh for 1 minute

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// The public site is prerendered to static HTML at build time (see scripts/
// prerender.js) so crawlers receive full content, headings, metadata, JSON-LD
// and internal links. On the client we mount with createRoot: it reconciles
// into the prerendered container and takes over interactivity. We intentionally
// avoid hydrateRoot because several pages fetch content on mount (their first
// client render is a loading state), which would otherwise cause hydration
// mismatches. Crawlers keep the static HTML; users get an instant first paint.
ReactDOM.createRoot(container).render(app);
